import React, { useState, useCallback, useEffect, lazy, Suspense } from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  FlatList,
  KeyboardAvoidingView,
  Platform,
  Keyboard,
  ActivityIndicator
} from 'react-native';
import { useNavigation } from "@react-navigation/native";
import Ionicons from '@expo/vector-icons/Ionicons';
import SimpleLineIcons from '@expo/vector-icons/SimpleLineIcons';
import Entypo from '@expo/vector-icons/Entypo';

import { sendMessage } from '../services/apiCall';

import Markdown from 'react-native-markdown-display';
let LoaderKit;
if (Platform.OS === 'android' || Platform.OS === 'ios') {
  LoaderKit = lazy(() => import('react-native-loader-kit'));
}

const ChatView = ({setUserBalance}) => {
  const [messages, setMessages] = useState([]);
  const [inputText, setInputText] = useState('');
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackProvided, setFeedbackProvided] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const [sessionId, setSessionId] = useState(null);
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  const navigation = useNavigation();
  const [suggestionBoxVisible, setSuggestionBoxVisible]=useState(true);

  useEffect(() => {
    navigation.setOptions({ headerShown: false });

    const keyboardDidShowListener = Keyboard.addListener(
      'keyboardDidShow',
      (event) => {
        setKeyboardOffset(event.endCoordinates.height);
      }
    );
    const keyboardDidHideListener = Keyboard.addListener(
      'keyboardDidHide',
      () => {
        setKeyboardOffset(0);
      }
    );

    return () => {
      keyboardDidHideListener.remove();
      keyboardDidShowListener.remove();
    };
  }, [navigation]);

  useEffect(() => {
    setMessages([
      {
        _id: 1,
        text: 'Namaste! How Can I Help You ?',
        createdAt: new Date(),
        user: {
          _id: 2,
          name: 'astroGPT',
          avatar: 'https://sgpublicbucket.s3.ap-south-1.amazonaws.com/image+2+(3).png',
        },
      },
    ]);
  }, []);

  const generateRandomId = () => {
    return Math.random().toString(36).substr(2, 9);
  };

  const getFeedbackMessages = (inputArray) => {
    return inputArray.map(item => {
      return {
        role: item.user._id === 1 ? "user" : "ai",
        message: item.text
      };
    });
  };

  const fetchData = async (userMessages) => {
    setLoading(true);
    setSuggestionBoxVisible(false)
    try {
      const messagebody ={
        message: userMessages[0]?.text,
        first_time: isFirstTime,
        session_id: sessionId
    }
    const response = await sendMessage(messagebody)
      const newMessage = {
        _id: generateRandomId(),
        text: String(response?.data?.data),
        createdAt: new Date(),
        user: {
          _id: 2,
          name: 'astroGPT',
          avatar: 'https://sgpublicbucket.s3.ap-south-1.amazonaws.com/image+2+(3).png',
        },
      };
      setMessages(prevMessages => [newMessage, ...prevMessages]);
      setSessionId(response?.data?.session_id);
      setUserBalance(response?.data?.coins);
      setIsFirstTime(false);
      setFeedbackProvided(false);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };
const initialMessage = 'Namaste! How Can I Help You ?';
  const newChat = () => {
    setMessages([
      {
        _id: 1,
        text: initialMessage,
        createdAt: new Date(),
        user: {
          _id: 2,
          name: 'astroGPT',
          avatar: 'https://sgpublicbucket.s3.ap-south-1.amazonaws.com/image+2+(3).png',
        },
      },
    ]);
  };

  const onSend = useCallback(() => {
    if (inputText.trim().length > 0) {
      const newMessage = {
        _id: generateRandomId(),
        text: inputText,
        createdAt: new Date(),
        user: {
          _id: 1,
          name: 'User',
        },
      };
      setMessages(prevMessages => [newMessage, ...prevMessages]);
      setInputText('');
      fetchData([newMessage]);
    }
  }, [inputText]);

  const toggleTheme = () => {
    setIsDarkMode(prevMode => !prevMode);
  };

  function isOddButNotOneMessages(msg) {
    return msg % 2 !== 0 && msg !== 1;
  }

  const feedbackContainer = () => {
    if (feedbackMessage) {
      return (
        <View style={styles.feedbackContainer}>
          <Text style={styles.feedbackText}>{feedbackMessage}</Text>
        </View>
      );
    } else if (isOddButNotOneMessages(messages.length) && !feedbackProvided) {
      return (
        <View style={styles.feedbackContainer}>
          <Text style={styles.feedbackText}>Please provide feedback on the Response:</Text>
          <TouchableOpacity style={styles.iconContainer} onPress={() => { callFeedback(1) }}>
            <Ionicons name="thumbs-up" size={20} color="#0078fe" />
          </TouchableOpacity>
          <TouchableOpacity style={styles.iconContainer} onPress={() => { callFeedback(2) }}>
            <Ionicons name="thumbs-down" size={20} color="#0078fe" />
          </TouchableOpacity>
        </View>
      );
    }
    return null;
  }

  const renderItem = ({ item }) => (
    <View
      style={[
        styles.messageContainer,
        {
          alignSelf: item.user._id === 1 ? 'flex-end' : 'flex-start',
          backgroundColor: item.user._id === 1 ? '#f0df21' : '#eeeeee',
          marginBottom: item.text === initialMessage && suggestionBoxVisible ? 80 :0,
         fontWeight: 'bold'
        },
      ]}
    >
       <Markdown
        style={{
          body: {
            color: '#000',
            overflowY: 'auto',
            maxWidth: '100%',
            fontWeight: 'bold'
          },
          strong: {
            fontWeight: 'bold'
          }
        }}

      >
        {item.text}
      </Markdown>
        
    </View>
  );

  const suggestions = [
    { id: '1', icon: 'suitcase', topic: 'Career', source:'Entypo' },
    { id: '2', icon: 'heart', topic: 'Love', source:'Entypo' },
    { id: '3', icon: 'book', topic: 'Education',source:'Entypo' },
    { id: '4', icon: 'diamond', topic: 'Marriage', source:'SimpleLineIcons' },
  ];

  const onSendWithText = (text) => {
    if (text.trim().length > 0) {
      const newMessage = {
        _id: generateRandomId(),
        text: text,
        createdAt: new Date(),
        user: {
          _id: 1,
          name: 'User',
        },
      };
      setMessages(prevMessages => [newMessage, ...prevMessages]);
      setInputText('');
      fetchData([newMessage]);
    }
  };

  const renderSuggestion = ({ item }) => (
    <TouchableOpacity style={styles.suggestionBox} onPress={() => {
      const topic = item.topic;
      setInputText(topic);
      setTimeout(() => {
        onSendWithText(topic);
      }, 0);
    }}>
      {item.source === 'SimpleLineIcons' &&  <SimpleLineIcons name={item.icon} size={25} color="#000" /> }
      { item.source === 'Entypo' && <Entypo name={item.icon} size={25} color="#000" />}
      <Text style={styles.suggestionText}>{item.topic}</Text>
    </TouchableOpacity>
  );

  const renderLoader = (loading) => {
    if (!loading) {
      return null;
    }
  
    if (Platform.OS === 'android' || Platform.OS === 'ios') {
      return (
        <Suspense fallback={<ActivityIndicator size="large" color="#f0df21" style={{ alignSelf: 'center' }} />}>
          <LoaderKit
            style={{ width: 50, height: 50, alignSelf: 'center' }}
            name={'BallPulse'}
            color={'#f0df21'}
          />
        </Suspense>
      );
    } else {
      return (
        <ActivityIndicator
          size="large"
          color="#f0df21"
          style={{ alignSelf: 'center' }}
        />
      );
    }
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{flex:1}}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 64 : 0}
    >
      <View style={{flex: 1, justifyContent: 'flex-end'}}>
        <FlatList
          data={messages}
          renderItem={renderItem}
          keyExtractor={item => item._id}
          inverted
          contentContainerStyle={{ paddingVertical: 20 }}
          style={{ flex: 1 }}
        />
        {renderLoader(loading)}
        {suggestionBoxVisible && (
          <FlatList
            data={suggestions}
            renderItem={renderSuggestion}
            keyExtractor={item => item.id}
            horizontal
            contentContainerStyle={styles.suggestionList}
            showsHorizontalScrollIndicator={false}
            style={styles.suggestionContainer}
          />
        )}
        <View style={[styles.inputContainer]}>
          <TextInput
            style={[styles.input, { color: '#000' }]}
            placeholder="Type a message..."
            placeholderTextColor={isDarkMode ? '#555' : '#999'}
            value={inputText}
            onChangeText={setInputText}
          />
          <TouchableOpacity onPress={onSend} style={styles.sendButton} disabled={loading}>
            <Ionicons name="send" size={20} color="black" />
          </TouchableOpacity>
        </View>
      </View>
    </KeyboardAvoidingView>
  );
};

const styles = StyleSheet.create({
  toggleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 10,
  },
  messageContainer: {
    borderRadius: 10,
    marginTop: 5,
    paddingVertical: 5,
    maxWidth: '100%',
    marginHorizontal: 5,
    paddingHorizontal: 10,
    flex: 1
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 2,
    borderColor: '#000',
    borderRadius: 25,
    marginHorizontal: 5,
    backgroundColor: '#fff',
    marginBottom: 10,
  },
  input: {
    flex: 1,
    padding: 10,
    borderRadius: 25,
    backgroundColor: '#fff',
    marginRight: 10,
  },
  sendButton: {
    padding: 10,
    backgroundColor: '#f0df21',
    borderRadius: 70,
    marginRight: 10,
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#fff',
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  headerText: {
    color: '#000',
    fontSize: 18,
  },
  title: {
    fontWeight: 'bold',
  },
  feedbackContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
    paddingVertical: 10,
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
    marginVertical: 10,
  },
  feedbackText: {
    marginRight: 5,
    fontSize: 15,
    color: '#333',
  },
  iconContainer: {
    padding: 10,
    borderRadius: 50,
    backgroundColor: '#ececec',
    marginLeft: 5,
  },
  loadingContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 10,
  },
  loadingCircle: {
    width: 10,
    height: 10,
    backgroundColor: '#000',
    borderRadius: 5,
    margin: 5,
  },
  suggestionList: {
    paddingVertical: 10,
    paddingHorizontal: 5,
  },
  suggestionBox: {
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
    margin: 5,
    backgroundColor: '#f0df21',
    borderRadius: 10,
    height: 60,
  },
  suggestionText: {
    marginTop: 5,
    color: '#000',
    fontSize: 14,
    textAlign: 'center',
  },
  suggestionContainer: {
    position: 'absolute',
    bottom: 60,
    width: '100%',
  },
});

export default ChatView;
